import axios from 'axios'
import { RmaStatusPostApiUrl,CloseRmaPostApiUrl,DetailsOnPageLoadApiUrl } from '@/GlobalConfig/app-config';

class NewRmaStatus{
    public async NewRmaStatusSavePost(data){
        const Url = RmaStatusPostApiUrl;
        return axios({
            method: 'post',
            url: Url,
            data: data,
        });
    }
    public async CloseRmaPostApi(data){
        const Url = CloseRmaPostApiUrl;
        return axios({
            method:"post",
            url:Url,
            data:data,
        });

    }
    public async DetailsDisplayOnPageLoad(data){
        const URl = DetailsOnPageLoadApiUrl;
        return axios({
            method:"post",
            url:URl,
            data:data,
        });
    }
}

export const documentobjrmastatus = new NewRmaStatus();